export const ListAndDetailSamplesCustomizePageInfo = () => {
    return (
        <>
            You can customize the ListAndDetail component in the following way.
            <ul>
                <li>If you don't specify any searchFields, the search box doens't show.</li>
                <li>If you don't specify a newUrl, the new button doesn't show.</li>
                <li>If you don't specify an onDeleting function, the delete checkboxes and delete button doesn't show.</li>
                <li>If you don't specify an editUrl, then clicking the button does nothing, you have to take care of that functionality
                    yourself. (In this example buttons are added to each list item).</li>
            </ul>
            This example shows all these things.
        </>
    )
}
